<template>
  <div class="progress-bar">
    <div class="progress-value" :class="{ smooth, failed }" :style="{ width: widthRef }"></div>
  </div>
</template>

<style lang="scss" scoped>
.progress-bar {
  height: 4px;
  background-color: #eee;
}

.progress-value {
  height: 100%;
  width: 0%;
  background-color: limegreen;
  transition: width 0.1s ease-in-out;

  &.smooth {
    transition: width 0.7s ease-in-out;
  }

  &.failed {
    background-color: var(--bs-warning);
  }
}
</style>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  value: number
  max?: number
  smooth?: boolean
  failed?: boolean
}>(), {
  max: 1,
})

const widthRef = computed(() => {
  const pct = props.max > 0 ? (props.value / props.max) * 100 : 0
  return `${pct}%`
})
</script>
